<div class="one-time-items-container">
    <p-table [value]="items" class="items">
        <ng-template pTemplate="header">
            <tr>
                <th class="col-qty" style="width: 20%;">Qty</th>
                <th style="width: 30%;">Desc</th>
                <th class="col-rate" style="width: 15%;">Rate</th>
                <th class="col-type" style="width: 15%;">AR Type</th>
                <th class="col-amount" style="width: 15%;">Amount</th>
                <th class="col-remove" style="width: 5%;">Remove</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-i="rowIndex">
            <tr>
                <td style="width: 20%;">
                    <input pInputText type="text" [(ngModel)]="rowData.qty" (focusout)="qtyLostFocus($event, rowData)"
                        onclick="this.setSelectionRange(0, this.value.length)" class="cell-qty" [ngModelOptions]="{standalone: true}">
                </td>
                <td style="width: 30%;">
                    <p-dropdown [options]="availableLineItems" [(ngModel)]="rowData.desc"
                        [style]="{'width':'100%','height':'100%'}"
                        (onChange)="changeLineItem($event, rowData)" appendTo="body" [ngModelOptions]="{standalone: true}"></p-dropdown>

                </td>
                <td style="width: 15%;">
                    {{rowData.rate | currency:'USD':'symbol'}}
                </td>
                <td style="width: 15%;">
                    {{rowData.type}}
                </td>
                <td style="width: 15%;">
                    {{rowData.amount | currency:'USD':'symbol'}}
                </td>
                <td style="width: 5%;">
                    <button type="button" pButton icon="pi pi-trash" iconPos="right" (click)="removeLineItem(i)" class="p-button-rounded no-underline"></button>
                </td>
            </tr>
            <tr *ngIf="allowNotes">
                <td colspan="4">
                    <input pInputText type="text" placeholder="Optional line note" [(ngModel)]="rowData.notes" [ngModelOptions]="{standalone: true}">
                </td>
                <td colspan="2"></td>
            </tr>
        </ng-template>
    </p-table>

    <button pButton type="button" class="w-2 mt-2" (click)="addLineItem()">Add Item</button>
</div>
